import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import Indentation from '../../../../../components/Simple/Indentation';
import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.traditionalAntiVirus;
const pageId = pageSchema.pageId;

function BaseTraditionalAntiVirus({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);

    const manageInSmp      = pageData[pageSchema.manageInSmp];
    const mode             = pageData[pageSchema.mode];
    const scanIncoming     = pageData[pageSchema.scanIncoming];
    const scanIncomingHttp = pageData[pageSchema.scanIncomingHttp];
    const scanIncomingSmtp = pageData[pageSchema.scanIncomingSmtp];
    const scanIncomingFtp  = pageData[pageSchema.scanIncomingFtp];
    const scanOutgoing     = pageData[pageSchema.scanOutgoing];
    const scanOutgoingHttp = pageData[pageSchema.scanOutgoingHttp];
    const scanOutgoingSmtp = pageData[pageSchema.scanOutgoingSmtp];
    const scanOutgoingFtp  = pageData[pageSchema.scanOutgoingFtp];
    const scanInternal     = pageData[pageSchema.scanInternal];
    const networks         = pageData[pageSchema.networks];
    const scanInternalHttp = pageData[pageSchema.scanInternalHttp];
    const scanInternalSmtp = pageData[pageSchema.scanInternalSmtp];
    const scanInternalFtp  = pageData[pageSchema.scanInternalFtp];
    const track            = pageData[pageSchema.track];
    const detectOnly       = pageData[pageSchema.detectOnly];
    
    const networkValues    = pageSchema.networkValues;
    const trackValues      = pageSchema.trackValues;

    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLAN.T_ANTI_VIRUS.T_ANTI_VIRUS')} managedInSmp={manageInSmp}>
                <RowLayout>
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>
                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                {/* Scan incoming files */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={scanIncoming}
                    onChange={e => setPageValue(pageSchema.scanIncoming, e.target.checked)}
                    label={t('SMP.PLAN.T_ANTI_VIRUS.LINE1')}
                />
                {
                    scanIncoming && (
                    <Indentation>
                        {/* From web */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanIncomingHttp}
                            onChange={e => setPageValue(pageSchema.scanIncomingHttp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.WEB')}
                        />
                        {/* From mail */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanIncomingSmtp}
                            onChange={e => setPageValue(pageSchema.scanIncomingSmtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.MAIL')}
                        />
                        {/* From ftp */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanIncomingFtp}
                            onChange={e => setPageValue(pageSchema.scanIncomingFtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.FTP')}
                        />
                    </Indentation>
                    )
                }
                {/* Scan outgoing files */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={scanOutgoing}
                    onChange={e => setPageValue(pageSchema.scanOutgoing, e.target.checked)}
                    label={t('SMP.PLAN.T_ANTI_VIRUS.LINE1')}
                />
                {
                    scanOutgoing && (
                    <Indentation>
                        {/* From web */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanOutgoingHttp}
                            onChange={e => setPageValue(pageSchema.scanOutgoingHttp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.WEB')}
                        />
                        {/* From mail */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanOutgoingSmtp}
                            onChange={e => setPageValue(pageSchema.scanOutgoingSmtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.MAIL')}
                        />
                        {/* From ftp */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanOutgoingFtp}
                            onChange={e => setPageValue(pageSchema.scanOutgoingFtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.FTP')}
                        />
                    </Indentation>
                    )
                }
                {/* Scan internal files */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={scanInternal}
                    onChange={e => setPageValue(pageSchema.scanInternal, e.target.checked)}
                    label={t('SMP.PLAN.T_ANTI_VIRUS.LINE1')}
                />
                {
                    scanInternal && (
                    <Indentation>
                        <SMCSelect
                            disabled={pageDisabled || !manageInSmp}
                            value={networks} onChange={e => setPageValue(pageSchema.networks, e.target.value)}>
                            <SMCOption value={networkValues.allInternal}>{t('SMP.PLAN.T_ANTI_VIRUS.ALL_INTERNAL_NETWORKS')}</SMCOption>
                            <SMCOption value={networkValues.dmzToInternal}>{t('SMP.PLAN.T_ANTI_VIRUS.DMZ_TO_INTERNAL_NETWORKS')}</SMCOption>
                        </SMCSelect>
                        {/* From web */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanInternalHttp}
                            onChange={e => setPageValue(pageSchema.scanInternalHttp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.WEB')}
                        />
                        {/* From mail */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanInternalSmtp}
                            onChange={e => setPageValue(pageSchema.scanInternalSmtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.MAIL')}
                        />
                        {/* From ftp */}
                        <SMCCheckbox
                            disabled={pageDisabled || !manageInSmp}
                            checked={scanInternalFtp}
                            onChange={e => setPageValue(pageSchema.scanInternalFtp, e.target.checked)}
                            label={t('SMP.PLAN.T_ANTI_VIRUS.FTP')}
                        />
                    </Indentation>
                    )
                }

                <EmptyRow />

                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    label={t('SMP.PLAN.T_ANTI_VIRUS.TRACKING_OPTIONS')}
                    value={track}
                    onChange={e => setPageValue(pageSchema.track, e.target.value)}
                >
                    <SMCOption value={trackValues.log}>{t('SMP.LOG')}</SMCOption>
                    <SMCOption value={trackValues.alert}>{t('SMP.ALERT')}</SMCOption>
                    <SMCOption value={trackValues.none}>{t('SMP.NONE')}</SMCOption>
                </SMCSelect>

                <SMCCheckbox
                    label={t('SMP.PLAN.DETECT_ONLY_MODE')}
                    checked={detectOnly}
                    onChange={e => setPageValue(pageSchema.detectOnly, e.target.checked)}
                />

                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.T_ANTI_VIRUS.LINE4')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseTraditionalAntiVirus;